var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Black / Arrow Right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M7.08104 3.94972C6.67053 3.5895 6.63726 2.97301 7.00671 2.57277C7.34775 2.20331 7.91274 2.14724 8.32052 2.42413L8.41897 2.5003L18.419 11.2753C18.8288 11.6349 18.8581 12.2425 18.5068 12.6375L18.419 12.7247L8.41897 21.4997C8.00846 21.8599 7.37617 21.8275 7.00671 21.4272C6.66568 21.0578 6.6678 20.5041 6.99302 20.1377L7.08104 20.0503L16.255 12L7.08104 3.94972Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.df552d2e09571afcaab00387352b63fd.svg";
export { ForwardRef as ReactComponent };